export const ENDPOINTS = {
  create: 'transactions/process',
  repeat: 'transactions/get',
};
